import { Step } from "react-joyride";

/**
 * Guided tour steps for the Evaluation Panel step.
 *
 * Each step targets a `data-testid` attribute rendered in the step.
 * If a target isn't present (e.g. panel mode not selected), Joyride will auto-skip it.
 */
export const evaluationPanelSteps: Step[] = [
	{
		target: '[data-testid="panel-mode-solo"]',
		content: (
			<div className="text-sm">
				<h3 className="mb-2 text-base font-semibold">Evaluation Mode</h3>
				<p>
					Choose how you want to evaluate submissions. You can score
					everything yourself (solo) or assemble a panel of evaluators.
				</p>
			</div>
		),
		placement: "bottom",
		disableBeacon: true,
	},
	{
		target: '[data-testid="add-member-form"]',
		content: (
			<div className="text-sm">
				<h3 className="mb-2 text-base font-semibold">Add Panel Members</h3>
				<p>
					Add internal colleagues or external experts to the evaluation panel.
					Search by name or enter an email address for external members.
				</p>
			</div>
		),
		placement: "bottom",
		disableBeacon: true,
	},
	{
		target: '[data-testid="panel-members-table"]',
		content: (
			<div className="text-sm">
				<h3 className="mb-2 text-base font-semibold">Panel Members</h3>
				<p>
					View all panel members and their invitation status. You can remove
					members or resend invitations from here.
				</p>
				<p className="mt-2 text-gray-500">
					Members must accept their invitation before they can begin scoring.
				</p>
			</div>
		),
		placement: "bottom",
		disableBeacon: true,
	},
	{
		target: '[data-testid="proceed-invitations-btn"]',
		content: (
			<div className="text-sm">
				<h3 className="mb-2 text-base font-semibold">Send Invitations</h3>
				<p>
					Once you&apos;ve added all panel members, send invitations so they
					can begin their evaluations. You can also continue without sending
					and invite later.
				</p>
			</div>
		),
		placement: "top",
		disableBeacon: true,
	},
];
